// extracted by mini-css-extract-plugin
export default {"stepTextInput__label":"StepTextInput_stepTextInput__label__NfIQ2","stepTextInput__item":"StepTextInput_stepTextInput__item__MLMEm"};